/* Autogenerated file. Do not edit manually. */
/* tslint:disable */
/* eslint-disable */
import { Signer, utils, Contract, ContractFactory, Overrides } from "ethers";
import { Provider, TransactionRequest } from "@ethersproject/providers";
import type {
  InterestRateModelXAI,
  InterestRateModelXAIInterface,
  IInterestRateModel,
} from "../InterestRateModelXAI";

const _abi = [
  {
    inputs: [
      {
        components: [
          {
            internalType: "int256",
            name: "uopt",
            type: "int256",
          },
          {
            internalType: "int256",
            name: "ucrit",
            type: "int256",
          },
          {
            internalType: "int256",
            name: "ulow",
            type: "int256",
          },
          {
            internalType: "int256",
            name: "ki",
            type: "int256",
          },
          {
            internalType: "int256",
            name: "kcrit",
            type: "int256",
          },
          {
            internalType: "int256",
            name: "klow",
            type: "int256",
          },
          {
            internalType: "int256",
            name: "klin",
            type: "int256",
          },
          {
            internalType: "int256",
            name: "beta",
            type: "int256",
          },
          {
            internalType: "int256",
            name: "ri",
            type: "int256",
          },
          {
            internalType: "int256",
            name: "Tcrit",
            type: "int256",
          },
        ],
        internalType: "struct IInterestRateModel.Config",
        name: "_config",
        type: "tuple",
      },
    ],
    stateMutability: "nonpayable",
    type: "constructor",
  },
  {
    inputs: [],
    name: "InvalidBeta",
    type: "error",
  },
  {
    inputs: [],
    name: "InvalidKcrit",
    type: "error",
  },
  {
    inputs: [],
    name: "InvalidKi",
    type: "error",
  },
  {
    inputs: [],
    name: "InvalidKlin",
    type: "error",
  },
  {
    inputs: [],
    name: "InvalidKlow",
    type: "error",
  },
  {
    inputs: [],
    name: "InvalidRi",
    type: "error",
  },
  {
    inputs: [],
    name: "InvalidTcrit",
    type: "error",
  },
  {
    inputs: [],
    name: "InvalidTimestamps",
    type: "error",
  },
  {
    inputs: [],
    name: "InvalidUcrit",
    type: "error",
  },
  {
    inputs: [],
    name: "InvalidUlow",
    type: "error",
  },
  {
    inputs: [],
    name: "InvalidUopt",
    type: "error",
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: true,
        internalType: "address",
        name: "silo",
        type: "address",
      },
      {
        indexed: true,
        internalType: "address",
        name: "asset",
        type: "address",
      },
      {
        components: [
          {
            internalType: "int256",
            name: "uopt",
            type: "int256",
          },
          {
            internalType: "int256",
            name: "ucrit",
            type: "int256",
          },
          {
            internalType: "int256",
            name: "ulow",
            type: "int256",
          },
          {
            internalType: "int256",
            name: "ki",
            type: "int256",
          },
          {
            internalType: "int256",
            name: "kcrit",
            type: "int256",
          },
          {
            internalType: "int256",
            name: "klow",
            type: "int256",
          },
          {
            internalType: "int256",
            name: "klin",
            type: "int256",
          },
          {
            internalType: "int256",
            name: "beta",
            type: "int256",
          },
          {
            internalType: "int256",
            name: "ri",
            type: "int256",
          },
          {
            internalType: "int256",
            name: "Tcrit",
            type: "int256",
          },
        ],
        indexed: false,
        internalType: "struct IInterestRateModel.Config",
        name: "config",
        type: "tuple",
      },
    ],
    name: "ConfigUpdate",
    type: "event",
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: true,
        internalType: "address",
        name: "newPendingOwner",
        type: "address",
      },
    ],
    name: "OwnershipPending",
    type: "event",
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: true,
        internalType: "address",
        name: "newOwner",
        type: "address",
      },
    ],
    name: "OwnershipTransferred",
    type: "event",
  },
  {
    inputs: [],
    name: "ASSET_DATA_OVERFLOW_LIMIT",
    outputs: [
      {
        internalType: "uint256",
        name: "",
        type: "uint256",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [],
    name: "DP",
    outputs: [
      {
        internalType: "uint256",
        name: "",
        type: "uint256",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [],
    name: "RCOMP_MAX",
    outputs: [
      {
        internalType: "uint256",
        name: "",
        type: "uint256",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [],
    name: "X_MAX",
    outputs: [
      {
        internalType: "int256",
        name: "",
        type: "int256",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [],
    name: "acceptOwnership",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        components: [
          {
            internalType: "int256",
            name: "uopt",
            type: "int256",
          },
          {
            internalType: "int256",
            name: "ucrit",
            type: "int256",
          },
          {
            internalType: "int256",
            name: "ulow",
            type: "int256",
          },
          {
            internalType: "int256",
            name: "ki",
            type: "int256",
          },
          {
            internalType: "int256",
            name: "kcrit",
            type: "int256",
          },
          {
            internalType: "int256",
            name: "klow",
            type: "int256",
          },
          {
            internalType: "int256",
            name: "klin",
            type: "int256",
          },
          {
            internalType: "int256",
            name: "beta",
            type: "int256",
          },
          {
            internalType: "int256",
            name: "ri",
            type: "int256",
          },
          {
            internalType: "int256",
            name: "Tcrit",
            type: "int256",
          },
        ],
        internalType: "struct IInterestRateModel.Config",
        name: "_c",
        type: "tuple",
      },
      {
        internalType: "uint256",
        name: "_totalDeposits",
        type: "uint256",
      },
      {
        internalType: "uint256",
        name: "_totalBorrowAmount",
        type: "uint256",
      },
      {
        internalType: "uint256",
        name: "_interestRateTimestamp",
        type: "uint256",
      },
      {
        internalType: "uint256",
        name: "_blockTimestamp",
        type: "uint256",
      },
    ],
    name: "calculateCompoundInterestRate",
    outputs: [
      {
        internalType: "uint256",
        name: "rcomp",
        type: "uint256",
      },
      {
        internalType: "int256",
        name: "ri",
        type: "int256",
      },
      {
        internalType: "int256",
        name: "Tcrit",
        type: "int256",
      },
    ],
    stateMutability: "pure",
    type: "function",
  },
  {
    inputs: [
      {
        components: [
          {
            internalType: "int256",
            name: "uopt",
            type: "int256",
          },
          {
            internalType: "int256",
            name: "ucrit",
            type: "int256",
          },
          {
            internalType: "int256",
            name: "ulow",
            type: "int256",
          },
          {
            internalType: "int256",
            name: "ki",
            type: "int256",
          },
          {
            internalType: "int256",
            name: "kcrit",
            type: "int256",
          },
          {
            internalType: "int256",
            name: "klow",
            type: "int256",
          },
          {
            internalType: "int256",
            name: "klin",
            type: "int256",
          },
          {
            internalType: "int256",
            name: "beta",
            type: "int256",
          },
          {
            internalType: "int256",
            name: "ri",
            type: "int256",
          },
          {
            internalType: "int256",
            name: "Tcrit",
            type: "int256",
          },
        ],
        internalType: "struct IInterestRateModel.Config",
        name: "_c",
        type: "tuple",
      },
      {
        internalType: "uint256",
        name: "_totalDeposits",
        type: "uint256",
      },
      {
        internalType: "uint256",
        name: "_totalBorrowAmount",
        type: "uint256",
      },
      {
        internalType: "uint256",
        name: "_interestRateTimestamp",
        type: "uint256",
      },
      {
        internalType: "uint256",
        name: "_blockTimestamp",
        type: "uint256",
      },
    ],
    name: "calculateCompoundInterestRateWithOverflowDetection",
    outputs: [
      {
        internalType: "uint256",
        name: "rcomp",
        type: "uint256",
      },
      {
        internalType: "int256",
        name: "ri",
        type: "int256",
      },
      {
        internalType: "int256",
        name: "Tcrit",
        type: "int256",
      },
      {
        internalType: "bool",
        name: "overflow",
        type: "bool",
      },
    ],
    stateMutability: "pure",
    type: "function",
  },
  {
    inputs: [
      {
        components: [
          {
            internalType: "int256",
            name: "uopt",
            type: "int256",
          },
          {
            internalType: "int256",
            name: "ucrit",
            type: "int256",
          },
          {
            internalType: "int256",
            name: "ulow",
            type: "int256",
          },
          {
            internalType: "int256",
            name: "ki",
            type: "int256",
          },
          {
            internalType: "int256",
            name: "kcrit",
            type: "int256",
          },
          {
            internalType: "int256",
            name: "klow",
            type: "int256",
          },
          {
            internalType: "int256",
            name: "klin",
            type: "int256",
          },
          {
            internalType: "int256",
            name: "beta",
            type: "int256",
          },
          {
            internalType: "int256",
            name: "ri",
            type: "int256",
          },
          {
            internalType: "int256",
            name: "Tcrit",
            type: "int256",
          },
        ],
        internalType: "struct IInterestRateModel.Config",
        name: "_c",
        type: "tuple",
      },
      {
        internalType: "uint256",
        name: "_totalDeposits",
        type: "uint256",
      },
      {
        internalType: "uint256",
        name: "_totalBorrowAmount",
        type: "uint256",
      },
      {
        internalType: "uint256",
        name: "_interestRateTimestamp",
        type: "uint256",
      },
      {
        internalType: "uint256",
        name: "_blockTimestamp",
        type: "uint256",
      },
    ],
    name: "calculateCurrentInterestRate",
    outputs: [
      {
        internalType: "uint256",
        name: "rcur",
        type: "uint256",
      },
    ],
    stateMutability: "pure",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "",
        type: "address",
      },
      {
        internalType: "address",
        name: "",
        type: "address",
      },
    ],
    name: "config",
    outputs: [
      {
        internalType: "int256",
        name: "uopt",
        type: "int256",
      },
      {
        internalType: "int256",
        name: "ucrit",
        type: "int256",
      },
      {
        internalType: "int256",
        name: "ulow",
        type: "int256",
      },
      {
        internalType: "int256",
        name: "ki",
        type: "int256",
      },
      {
        internalType: "int256",
        name: "kcrit",
        type: "int256",
      },
      {
        internalType: "int256",
        name: "klow",
        type: "int256",
      },
      {
        internalType: "int256",
        name: "klin",
        type: "int256",
      },
      {
        internalType: "int256",
        name: "beta",
        type: "int256",
      },
      {
        internalType: "int256",
        name: "ri",
        type: "int256",
      },
      {
        internalType: "int256",
        name: "Tcrit",
        type: "int256",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "_silo",
        type: "address",
      },
      {
        internalType: "address",
        name: "_asset",
        type: "address",
      },
      {
        internalType: "uint256",
        name: "_blockTimestamp",
        type: "uint256",
      },
    ],
    name: "getCompoundInterestRate",
    outputs: [
      {
        internalType: "uint256",
        name: "rcomp",
        type: "uint256",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "_asset",
        type: "address",
      },
      {
        internalType: "uint256",
        name: "_blockTimestamp",
        type: "uint256",
      },
    ],
    name: "getCompoundInterestRateAndUpdate",
    outputs: [
      {
        internalType: "uint256",
        name: "rcomp",
        type: "uint256",
      },
    ],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "_silo",
        type: "address",
      },
      {
        internalType: "address",
        name: "_asset",
        type: "address",
      },
    ],
    name: "getConfig",
    outputs: [
      {
        components: [
          {
            internalType: "int256",
            name: "uopt",
            type: "int256",
          },
          {
            internalType: "int256",
            name: "ucrit",
            type: "int256",
          },
          {
            internalType: "int256",
            name: "ulow",
            type: "int256",
          },
          {
            internalType: "int256",
            name: "ki",
            type: "int256",
          },
          {
            internalType: "int256",
            name: "kcrit",
            type: "int256",
          },
          {
            internalType: "int256",
            name: "klow",
            type: "int256",
          },
          {
            internalType: "int256",
            name: "klin",
            type: "int256",
          },
          {
            internalType: "int256",
            name: "beta",
            type: "int256",
          },
          {
            internalType: "int256",
            name: "ri",
            type: "int256",
          },
          {
            internalType: "int256",
            name: "Tcrit",
            type: "int256",
          },
        ],
        internalType: "struct IInterestRateModel.Config",
        name: "",
        type: "tuple",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "_silo",
        type: "address",
      },
      {
        internalType: "address",
        name: "_asset",
        type: "address",
      },
      {
        internalType: "uint256",
        name: "_blockTimestamp",
        type: "uint256",
      },
    ],
    name: "getCurrentInterestRate",
    outputs: [
      {
        internalType: "uint256",
        name: "rcur",
        type: "uint256",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [],
    name: "interestRateModelPing",
    outputs: [
      {
        internalType: "bytes4",
        name: "",
        type: "bytes4",
      },
    ],
    stateMutability: "pure",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "_silo",
        type: "address",
      },
      {
        internalType: "address",
        name: "_asset",
        type: "address",
      },
      {
        internalType: "uint256",
        name: "_blockTimestamp",
        type: "uint256",
      },
    ],
    name: "overflowDetected",
    outputs: [
      {
        internalType: "bool",
        name: "overflow",
        type: "bool",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [],
    name: "owner",
    outputs: [
      {
        internalType: "address",
        name: "",
        type: "address",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [],
    name: "pendingOwner",
    outputs: [
      {
        internalType: "address",
        name: "",
        type: "address",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [],
    name: "removePendingOwnership",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [],
    name: "renounceOwnership",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "_silo",
        type: "address",
      },
      {
        internalType: "address",
        name: "_asset",
        type: "address",
      },
      {
        components: [
          {
            internalType: "int256",
            name: "uopt",
            type: "int256",
          },
          {
            internalType: "int256",
            name: "ucrit",
            type: "int256",
          },
          {
            internalType: "int256",
            name: "ulow",
            type: "int256",
          },
          {
            internalType: "int256",
            name: "ki",
            type: "int256",
          },
          {
            internalType: "int256",
            name: "kcrit",
            type: "int256",
          },
          {
            internalType: "int256",
            name: "klow",
            type: "int256",
          },
          {
            internalType: "int256",
            name: "klin",
            type: "int256",
          },
          {
            internalType: "int256",
            name: "beta",
            type: "int256",
          },
          {
            internalType: "int256",
            name: "ri",
            type: "int256",
          },
          {
            internalType: "int256",
            name: "Tcrit",
            type: "int256",
          },
        ],
        internalType: "struct IInterestRateModel.Config",
        name: "_config",
        type: "tuple",
      },
    ],
    name: "setConfig",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "newOwner",
        type: "address",
      },
    ],
    name: "transferOwnership",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "newPendingOwner",
        type: "address",
      },
    ],
    name: "transferPendingOwnership",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
];

const _bytecode =
  "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";

type InterestRateModelXAIConstructorParams =
  | [signer?: Signer]
  | ConstructorParameters<typeof ContractFactory>;

const isSuperArgs = (
  xs: InterestRateModelXAIConstructorParams
): xs is ConstructorParameters<typeof ContractFactory> => xs.length > 1;

export class InterestRateModelXAI__factory extends ContractFactory {
  constructor(...args: InterestRateModelXAIConstructorParams) {
    if (isSuperArgs(args)) {
      super(...args);
    } else {
      super(_abi, _bytecode, args[0]);
    }
    this.contractName = "InterestRateModelXAI";
  }

  deploy(
    _config: IInterestRateModel.ConfigStruct,
    overrides?: Overrides & { from?: string | Promise<string> }
  ): Promise<InterestRateModelXAI> {
    return super.deploy(
      _config,
      overrides || {}
    ) as Promise<InterestRateModelXAI>;
  }
  getDeployTransaction(
    _config: IInterestRateModel.ConfigStruct,
    overrides?: Overrides & { from?: string | Promise<string> }
  ): TransactionRequest {
    return super.getDeployTransaction(_config, overrides || {});
  }
  attach(address: string): InterestRateModelXAI {
    return super.attach(address) as InterestRateModelXAI;
  }
  connect(signer: Signer): InterestRateModelXAI__factory {
    return super.connect(signer) as InterestRateModelXAI__factory;
  }
  static readonly contractName: "InterestRateModelXAI";
  public readonly contractName: "InterestRateModelXAI";
  static readonly bytecode = _bytecode;
  static readonly abi = _abi;
  static createInterface(): InterestRateModelXAIInterface {
    return new utils.Interface(_abi) as InterestRateModelXAIInterface;
  }
  static connect(
    address: string,
    signerOrProvider: Signer | Provider
  ): InterestRateModelXAI {
    return new Contract(
      address,
      _abi,
      signerOrProvider
    ) as InterestRateModelXAI;
  }
}
